import { DIALOG_TYPE, LAUNCH_CALLER, LayoutConfig } from '@spartacus/storefront';
import { EmptyCartModalComponent } from './empty-cart-modal.component';

export const emptyCartModalLayoutConfig: LayoutConfig = {
  launch: {
    [LAUNCH_CALLER.EMPTY_CART]: {
      inlineRoot: true,
      component: EmptyCartModalComponent,
      dialogType: DIALOG_TYPE.DIALOG,
      dialogOptions: {
        onTop: true,
      },
    },
  },
};
